/* 布局 */
//前台
import Layout from "@views/layout";

const noticeRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
        {
        path: "notice/list",
        name: "NOTICE",
        meta: {
            title: "文章管理",
            keepAlive:true
        },
        component: () => import("@views/business/notice/index.vue"),
    },
        ],
};

export default noticeRouter;
